import { render, staticRenderFns } from "./OsdiMailField.vue?vue&type=template&id=55a1ef86&scoped=true&"
import script from "./OsdiMailField.vue?vue&type=script&lang=ts&"
export * from "./OsdiMailField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1ef86",
  null
  
)

export default component.exports